<template>
    <section class="blog-main-block">
        <div class="wrapper">
            <h1 v-html="title"></h1>
            <div class="blog-main-block__container">
                <transition-group name="fade">
                    <a :href="post.url" :key="post.url" class="blog-item" v-for="post in posts">
                        <span class="blog-item__bg" v-if="post.thumbnail != '#'" v-bind:style="{'background-image': 'url(' + post.thumbnail + ')'}"></span>
                        <span class="blog-item__text">
                            <time :datetime="post.datetime">{{post.date}}</time>
                            <span class="title">{{post.title}}</span>
                            <span class="desc">{{post.description}}</span>
                        </span>
                    </a>
                </transition-group>
            </div>
            <transition name="fade" :duration="300">
                <div class="blog-main-block__foot" v-show="posts.length < total">
                    <button class="button-pill inline" v-on:click="getPosts()">Загрузить ещё</button>
                </div>
            </transition>
        </div>
    </section>
</template>

<script>
    export default {
        props: ['parent', 'size', 'title'],
        data: function () {
            return {
                posts: [],
                currentPage: 0,
                total: 0
            };
        },
        methods: {
            getPosts() {
                var vm = this;
                $.getJSON("/umbraco/Surface/Blog/GetPosts",
                    {
                        parent: this.parent,
                        page: this.currentPage,
                        size: this.size
                    },
                    function onSuccess() {
                        console.log("success");
                    })
                    .done(function (data) {
                        vm.posts = vm.posts.concat(data.Posts);
                        vm.currentPage++;
                        vm.total = data.Total;
                    })
                    .fail(function () {
                        console.log('fail');
                    });
                }
        },
        mounted: function () {      
            this.getPosts();
        }
    }
</script>